import axios from "axios";
import { Link } from "react-router-dom";
import Loader from "react-loader-spinner";
import React, { useEffect, useState } from "react";

import "./style.css";

const CaseSection = () => {
  const [causes, setCauses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  useEffect(() => {
    axios
      .get(`${baseUrl}/cause`)
      .then((res) => {
        setLoading(false);
        setCauses(res.data.data);
      })
      .catch((err) => {
        setLoading(false);
        setLoadingError(true);
      });
  }, [baseUrl]);

  return (
    <div className="wpo-case-area-2 section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-section-title">
              <span>Our Causes</span>
              <h2>Popular Causes What You Should Know</h2>
            </div>
          </div>
        </div>
        <div className="wpo-case-wrap">
          <div className="row">
            {loading ? (
              <div className="result-container">
                <Loader type="Oval" color="#d90404" height={80} width={80} />
              </div>
            ) : loadingError ? (
              <div className="result-container">
                <p>Could not fetch causes. Refresh or check back later.</p>
              </div>
            ) : !causes.length ? (
              <div className="result-container">
                <p>No blog posts. Check back later.</p>
              </div>
            ) : (
              causes.map((cause) => (
                <div
                  className="col-lg-4 col-md-6 custom-grid col-12"
                  key={cause._id}
                >
                  <div className="wpo-case-item">
                    <div className="wpo-case-img">
                      <img src={cause.image} alt="" />
                    </div>
                    <div className="wpo-case-content">
                      <div className="wpo-case-text-top">
                        <h2>{cause.title}</h2>
                        <div className="progress-section">
                          <div className="process">
                            <div className="progress">
                              {/* TODO: IMPLEMENT DYNAMIC PROGRESS LATER */}
                              {/* <div className='progress-bar'>
                                <div className='progress-value'>
                                  <span>65.5</span>%
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                        <ul>
                          <li>
                            <span>Raised:</span> $ {cause.raisedAmount}
                          </li>
                          <li>
                            <span>Goal:</span> $ {cause.targetAmount}
                          </li>
                        </ul>
                      </div>
                      <div className="case-btn">
                        <ul>
                          <li>
                            <Link
                              onClick={ClickHandler}
                              to={`/case-single/${cause._id}`}
                            >
                              Learn More
                            </Link>
                          </li>
                          <li>
                            <Link
                              onClick={ClickHandler}
                              to={`/donate?causeId=${cause._id}`}
                            >
                              Donate Now
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseSection;
